import useGetExpiringPointsData from './useGetExpiringPointsData'
export default useGetExpiringPointsData
